import {Component} from 'react';
import {connect} from 'react-redux'
import logo from 'images/logo.png'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import Image from "react-graceful-image"
import Container from "react-bootstrap/Container"
import {
    isIndividualPlan,
    isInstitutionalPlan,
    isOpenRemunerationPlan,
    isProfilePlan,
    isPublicUser,
    isRealInstitutionalParentPlan,
    isStarterPlan,
    viewAdvancedFeatureVisible,
    viewJobFeatureVisible
} from 'shared/plans'
import DashboardSearch from "./DashboardSearch"
// import UserReports from '../../sections/UserReports';
import {Button} from "react-bootstrap"

const companiesAtRiskInfo = "This is a list of companies where executives may be interested in moving companies. OpenDirector looks at factors like if the company has a new CEO, total shareholder returns, executive turnover, director share trading, board strikes and other factors."
const ceoAtRiskInfo = "This is a ranking of CEOs who OpenDirector believes are at risk of losing their positions. CEO’s are ranked based on comparative changes in shareholder total return, remuneration, director share trading, board strikes and other factors."

class SideBarAndNavBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openRemUser: isOpenRemunerationPlan(props.user),
            publicUser: isPublicUser(props.user)
        }
    }

    _renderTooltip = (text, id) => {
        return (
            <OverlayTrigger
                placement="right"
                overlay={
                    <Tooltip id={`coming-soon-tooltip-${id}`}>
                        {text}
                    </Tooltip>
                }
            >
                <span className='fa fa-info ml-3'></span>
            </OverlayTrigger>
        )
    }

    _navPermClass = (type) => {
        const {user} = this.props

        const profileUser = isProfilePlan(user);
        const institutionalUser = isInstitutionalPlan(user);
        const institutionalSingleUser = isIndividualPlan(user);
        const starterUser = isStarterPlan(user);
        const validStarterPlan = starterUser || profileUser;
        const validInstitutionalPlan = institutionalUser || institutionalSingleUser;
        const validOpenDirectorSubscription = validStarterPlan || validInstitutionalPlan;
        const advancedFeature = viewAdvancedFeatureVisible(user);
        const jobFeature = viewJobFeatureVisible(user);

        let className
        switch (type) {
            case "power-search":
            case "companies-risk":
            case "rank-company":
            case "rank-director":
            case "rank-executive":
            case "analysis":
            case "director-renewal":
            case "director-share-buy":
            case "director-skill":
            case "director-committee":
            case "exec-departure":
            case "exec-risk":
            case "rem-viz":
                className = "nav-active"
                break
            case "exec-comp":
                className = "nav-active"
                break
            case "exec-summary":
            case "stat":
                className = validInstitutionalPlan ? "nav-active" : "nav-inactive"
                break;
            case "director-connection":
                className = (validInstitutionalPlan || profileUser) ? "nav-active" : "nav-inactive"
                break;
            case "rem-main":
            case "exec-comp-rem":
            case "board-comp-rem":
            case "ceo-rem-comp":
            case "board-policy":
            case "remuneration-policy":
            case "listed-companies":
                className = "nav-active"
                break
            case "report-main":
            case "board-count":
            case "esg":
            case "premium-main":
            case "exec-changes":
            case "director-change":
                className = validOpenDirectorSubscription ? "nav-active" : "nav-inactive"
                break;
            case "rank":
                className = validInstitutionalPlan ? "nav-drop-active" : "nav-drop-inactive"
                break;
            case "advance-feature":
                className = advancedFeature ? "nav-drop-active" : "nav-drop-inactive"
                break;
            case "position-post":
                className = jobFeature ? "nav-active" : "nav-inactive"
                break;
            case "my-profile":
            default:
                className = "nav-active"
        }

        return className
    }

    _renderSideBar = () => {
        const {user} = this.props
        const {openRemUser} = this.state

        return (
            <div bg="primary" className='react-sidebar'>
                <a href="#/root" className='my-4'>
                    <Image src={logo} style={{width: 38, height: 38, borderRadius: 3}} alt="Product Logo"/>
                </a>
                <ul style={{marginBottom: '10rem'}}>
                    {!openRemUser &&
                        <>
                        <li>
                            <a href="#/organisations" className={this._navPermClass("listed-companies")}>
                                <span className='fa fa-table-list fa-2x'/>
                                <br/>
                                Organisations
                            </a>
                        </li>
                        <li>
                            <a href="#/search" className={this._navPermClass("power-search")}>
                                <span className='fa fa-globe-asia fa-2x mt-0'/>
                                <br/>
                                Power Search
                            </a>
                        </li>
                        </>
                    }

                    {openRemUser && <>

                        <li>
                            <a href="#/organisations" className={this._navPermClass("listed-companies")}>
                                <span className='fa fa-table-list fa-2x'/>
                                <br/>
                                Organisations
                            </a>
                        </li>

                        <li>
                            <a href="#/remuneration-policy" className={this._navPermClass("remuneration-policy")}>
                                <span className='fa fa-spa fa-2x'/>
                                <br/>
                                Executive Remuneration Package
                            </a>
                        </li>

                        <li>
                            <a href="#/ceo-remuneration-components" className={this._navPermClass("ceo-rem-comp")}>
                                <span className='fa fa-drafting-compass fa-2x'/>
                                <br/>
                                Proxy Advisor Estimates
                            </a>
                        </li>

                        <li>
                            <a href="#/board-policy" className={this._navPermClass("board-policy")}>
                                <span className='fa fa-graduation-cap fa-2x'/>
                                <br/>
                                Board Details
                            </a>
                        </li>

                        <li>
                            <a href="#/search" className={this._navPermClass("power-search")}>
                                <span className='fa fa-globe-asia fa-2x mt-0'/>
                                <br/>
                                Power Search
                            </a>
                        </li>

                        <li>
                            <a href="#/rem-compare" className={this._navPermClass("exec-comp")}>
                                <span className='fa fa-microchip fa-2x'/>
                                <br/>
                                Executive Comparison
                            </a>
                        </li>
                    </>}

                    <li>
                        <a href="#/boards" className={this._navPermClass("board-main")}>
                            <span className='fa fa-users fa-2x'/>
                            <br/>
                            Boards
                        </a>
                    </li>
                    <li>
                        <a href="#/executives" className={this._navPermClass("executive-main")}>
                            <span className='fa fa-briefcase fa-2x'/>
                            <br/>
                            Executives
                        </a>
                    </li>
                    {!openRemUser && <>
                        <li>
                            <a href="#/member-profile" className={this._navPermClass("my-profile")}>
                                <span className='fa fa-address-card fa-2x'/>
                                <br/>
                                My Profile
                            </a>
                        </li>
                        <li>
                            <a href="/jobs" className={this._navPermClass("position-view")}>
                                <span className='fas fa-user-md fa-2x'/>
                                <br/>
                                Available Directorships
                            </a>
                        </li>
                        <li>
                            <a href="#/bubbles" className={this._navPermClass("bubbles-main")}>
                                <span className='fa fa-soap fa-2x'/>
                                <br/>
                                Bubbles
                            </a>
                        </li>
                    </>}
                </ul>
            </div>
        )
    }

    render() {
        const {user} = this.props
        const {openRemUser, publicUser} = this.state

        const profileUser = isProfilePlan(user);
        const institutionalUser = isInstitutionalPlan(user);
        const realInstitutionalParentUser = isRealInstitutionalParentPlan(user);
        const advancedFeature = viewAdvancedFeatureVisible(user);

        const titleName = "Core Information";
        return (
            <>
                <Navbar bg="white" expand="lg" className="shadow"
                        style={{zIndex: 1, position: 'unset', height: '5rem'}}>
                    <Container style={{maxWidth: '100%'}}>
                        <Navbar.Brand href="#/root" style={{width: '80px'}}>
                            <Image src={logo} style={{width: 38, height: 38, borderRadius: 3}} alt="Application Logo"/>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto top-search-bar">
                                <DashboardSearch/>
                            </Nav>

                            <Nav className="text-nowrap align-items-center">
                                <NavDropdown title={titleName} id="premium-nav-dropdown" alignRight
                                                className={this._navPermClass("premium-main")}>
                                    <NavDropdown.Item href='#'
                                                                className='pl-2 disabled'>Networks</NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#/company-risks"
                                                        className={this._navPermClass("companies-risk")}>
                                        Companies at risk
                                        {this._renderTooltip(companiesAtRiskInfo, '1')}
                                    </NavDropdown.Item>
                                    <NavDropdown.Item href="#/executive-risks"
                                                        className={this._navPermClass("exec-risk")}>
                                        CEOs at risk
                                        {this._renderTooltip(ceoAtRiskInfo, '2')}
                                    </NavDropdown.Item> */}
                                    <NavDropdown.Item href="#/connections"
                                                        className={this._navPermClass("director-connection")}>Director
                                        Networks</NavDropdown.Item>

                                    {
                                        // <NavDropdown.Divider/>

                                        // <NavDropdown.Item href='#'
                                        //                   className='pl-2 disabled'>Analytics</NavDropdown.Item>
                                        // <NavDropdown className={`${this._navPermClass("rank")} sub-dropdown ml-3`}
                                        //              title="Director and Company Rankings"
                                        //              id="rankings-nav-dropdown">
                                        //     <NavDropdown.Item href="#/company-ranking"
                                        //                       className={this._navPermClass("rank-company")}>Company</NavDropdown.Item>
                                        //     <NavDropdown.Item href="#/director-ranking"
                                        //                       className={this._navPermClass("rank-director")}>Director</NavDropdown.Item>
                                        //     <NavDropdown.Item href="#/executive-ranking"
                                        //                       className={this._navPermClass("rank-executive")}>Executive</NavDropdown.Item>
                                        // </NavDropdown>
                                        // <NavDropdown.Item href="#/director-analysis"
                                        //                   className={this._navPermClass("analysis")}>Director Return
                                        //     Analysis</NavDropdown.Item
                                    }

                                    <NavDropdown.Divider/>
                                    <NavDropdown.Item href='#'
                                                        className='pl-2 disabled'>Directors</NavDropdown.Item>
                                    <NavDropdown.Item href="#/non-executive-director-changes"
                                                        className={this._navPermClass("director-change")}>Non-Executive
                                        Director Changes</NavDropdown.Item>
                                    <NavDropdown.Item href="#/non-executive-director-renewals"
                                                        className={this._navPermClass("director-renewal")}>Non-Executive
                                        Director Renewals</NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#/company-director-shares"
                                                        className={this._navPermClass("director-share-buy")}>Director
                                        Shares Buys/Sells</NavDropdown.Item> */}
                                    <NavDropdown.Item href="#/skills-diversity"
                                                        className={this._navPermClass("director-skill")}>Board
                                        Skills
                                        and Experience</NavDropdown.Item>
                                    <NavDropdown.Item href="#/committee-membership"
                                                        className={this._navPermClass("director-committee")}>Committees</NavDropdown.Item>

                                    <NavDropdown.Divider/>
                                    <NavDropdown.Item href='#'
                                                        className='pl-2 disabled'>Executives</NavDropdown.Item>
                                    <NavDropdown.Item href="#/executive-changes"
                                                        className={this._navPermClass("exec-changes")}>Recent
                                        Executive Changes</NavDropdown.Item>
                                    <NavDropdown.Item href="#/executive-departures"
                                                        className={this._navPermClass("exec-departure")}>Executive
                                        Departures/Arrivals</NavDropdown.Item>

                                    <NavDropdown.Item href='#'
                                                            className='pl-2 disabled'>Remuneration</NavDropdown.Item>
                                    <NavDropdown.Item href="#/data-viz"
                                                        className={this._navPermClass("rem-viz")}>Visualisation</NavDropdown.Item>
                                    {/* <NavDropdown.Item href="#/remuneration-analytics"
                                                        className={this._navPermClass("rem-analytics")}>Analytics</NavDropdown.Item> */}
                                    <NavDropdown.Item href="#/executive-remunerations"
                                                    className={this._navPermClass("exec-comp-rem")}>Executive
                                    Company Rem</NavDropdown.Item>
                                    <NavDropdown.Item href="#/board-remunerations"
                                                    className={this._navPermClass("board-comp-rem")}>Board
                                        Company
                                        Rem</NavDropdown.Item>
                                    <NavDropdown.Divider/>

                                    {
                                        <>
                                            <NavDropdown.Divider/>
                                            <NavDropdown.Item href='#'
                                                                className='pl-2 disabled'>Other</NavDropdown.Item>
                                            <NavDropdown.Item href="#/directors-board-count"
                                                                className={this._navPermClass("board-count")}>Board
                                                count</NavDropdown.Item>
                                            {/* <NavDropdown.Item href="#/esg"
                                                                className={this._navPermClass("esg")}>ESG</NavDropdown.Item> */}
                                            <NavDropdown.Item href="#/statistics"
                                                                className={this._navPermClass("stat")}>Statistics</NavDropdown.Item>
                                        </>
                                    }

                                </NavDropdown>



                                <Nav.Link href="#/reports">Reports</Nav.Link>

                                {
                                    publicUser ? <>
                                        <Nav.Link href="/users/sign_in" style={{marginLeft: '2rem'}}>Login</Nav.Link>
                                    </> : <NavDropdown
                                        title={<span className='fa fa-user-circle'
                                                     style={{color: '#35d1be', fontSize: '2.5rem'}}/>}
                                        id="reports-nav-dropdown" alignRight className="user-round-nav">
                                        {(profileUser || institutionalUser) &&
                                            <NavDropdown.Item href="#/member-profile">Profile page</NavDropdown.Item>}
                                        {realInstitutionalParentUser &&
                                            <NavDropdown.Item href="#/member-user">Manage Users</NavDropdown.Item>}
                                        <NavDropdown.Item href="#/lists">Lists</NavDropdown.Item>
                                        <NavDropdown.Item href="#/positions">Post Positions</NavDropdown.Item>
                                        <NavDropdown.Item href="#/notifications">Notifications</NavDropdown.Item>
                                        <NavDropdown.Item href="#/settings">Settings</NavDropdown.Item>
                                    </NavDropdown>
                                }
                            </Nav>
                            <Button variant="primary" size="md" style={{borderRadius: 0}}
                                    href={'/users/sign_out'}>Logout</Button>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                {this._renderSideBar()}
            </>
        )
    }
}

function mapStateToProps(state) {
    const {users} = state

    return {
        user: users.user
    }
}

export default connect(mapStateToProps, null)(SideBarAndNavBar)
